/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".weight-set-entry-container[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-flow:column}.input-with-button-group[_ngcontent-%COMP%]{display:grid;grid-template-columns:5fr 1fr;grid-template-rows:1fr;grid-template-areas:'input button'}.input-with-button-group[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{grid-area:input}.input-with-button-group[_ngcontent-%COMP%]   #weight-edit-button[_ngcontent-%COMP%]{grid-area:button}"];
export { styles as styles };
